module.exports = __webpack_public_path__ + "static/media/main-logo.cb6d8d5b.png";